/*
  Reveal-on-scroll for the custom FLOW sections.

  Dawn's animations.js only observes elements carrying the `scroll-trigger`
  class, and not one of the ~40 flow-* sections has it — so with
  "Reveal sections on scroll" switched on, nothing on the storefront animated.

  This adds the behaviour without touching the section markup: the selectors
  below are matched at runtime, the elements get `.flow-reveal`, and an
  IntersectionObserver flips them to `.is-revealed` as they enter the viewport.
  Items inside the same parent stagger.

  Deliberately excluded:
    - the hero, which is the LCP element and must paint immediately;
    - the scrolling bar and ingredient marquees, which already animate;
    - `.flow-testimonials__card`, whose opacity and transform belong to the
      slideshow component.

  Because the starting styles are applied by this script rather than by the
  stylesheet, a JS failure leaves every section plainly visible.
*/

(function () {
  'use strict';

  var TARGETS = [
    // Home
    '.flow-comparison-table__intro',
    '.flow-comparison-table__mobile-card',
    '.flow-ingredients__header',
    '.flow-leave-out__header',
    '.flow-leave-out__item',
    '.flow-faqs__intro',
    '.flow-faqs__item',
    '.flow-indulgence__content-inner',
    '.flow-indulgence__media',
    '.flow-subscribe__content',
    '.flow-subscribe__image',
    '.flow-testimonials__intro',
    '.flow-knowledge__intro',
    '.flow-knowledge__card',

    // Product page
    '.fpdp-social__rating',
    '.fpdp-benefits__grid > *',
    '.fpdp-how__steps > *',
    '.fpdp-plans__grid > *',
    '.fpdp-reviews__grid > *',
    '.fpdp-faq__item',
    '.fpdp-guarantee__inner',

    // Science
    '.flow-science-reasons__header',
    '.flow-science-reasons__item',
    '.flow-science-botanicals__header',
    '.flow-science-botanicals__item',

    // Ingredients
    '.flow-ingredients-list__header',
    '.flow-ingredients-v2__header',
    '.flow-ingredients-v2__card',
    '.flow-ingredients-v2__item',

    // Reviews
    '.flow-reviews-grid__header',
    '.flow-reviews-grid__card',

    // Benefits
    '.flow-benefits-science__intro',
    '.flow-benefits-science__item'
  ].join(',');

  var REVEAL_CLASS = 'flow-reveal';
  var DONE_CLASS = 'is-revealed';

  function stagger(element) {
    var parent = element.parentElement;
    if (!parent) return 0;

    var order = 0;
    for (var i = 0; i < parent.children.length; i++) {
      if (parent.children[i] === element) break;
      if (parent.children[i].classList.contains(REVEAL_CLASS)) order++;
    }
    // Cap it so a long grid's last item isn't left waiting a second and a half.
    return Math.min(order, 5);
  }

  function onIntersect(entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add(DONE_CLASS);
      observer.unobserve(entry.target);
    });
  }

  function init(root) {
    var scope = root || document;
    var elements = scope.querySelectorAll(TARGETS);
    if (!elements.length) return;

    // In the theme editor sections re-render constantly; a merchant should
    // never be looking at a section that is waiting to be scrolled into view.
    var revealNow =
      (window.Shopify && window.Shopify.designMode) ||
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (revealNow) return;

    var observer = new IntersectionObserver(onIntersect, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.05
    });

    Array.prototype.forEach.call(elements, function (element) {
      if (element.classList.contains(REVEAL_CLASS)) return;
      element.classList.add(REVEAL_CLASS);
      element.style.setProperty('--flow-reveal-order', stagger(element));
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
